import { loader } from 'graphql.macro'

export default async function destroyClient ({ dataLoaders, variables }) {
  const schema = loader('./destroyClient.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      clientId: variables.id
    }
  })
  return response.destroyClient
}
